import speakersAPI from "../api/speakersAPI";

const state = {
  speakers: [],
  isFetching: false,
  errorStatus: null,
  hasFetchedSpeakers: false,
  visibleSpeakersCount: 20,
  defaultSpeakersCount: 20,
};

const actions = {
  async fetchSpeakers({commit}, {id, search}) {
    commit("updateIsFetching", true);

    try {
      const response = await speakersAPI.fetch(id, search);
      commit("updateSpeakers", {search, ...response});
      commit("updateVisibleSpeakersCount", state.defaultSpeakersCount);

      // reset error status to hide the error cover
      commit("updateErrorStatus", null);
    } catch (error) {
      console.error('Failed to fetch notification:', error.response);

      // show error cover
      commit("updateErrorStatus", error?.response?.status);
      throw  error;
    } finally {
      commit("updateIsFetching", false);
    }
  }
};

const mutations = {
  updateSpeakers(state, {search, ...payload}) {
    state.speakers = [
      ...payload.data.data,
    ];

    if (search) {
      state.hasFetchedSpeakers = false;
    } else {
      state.hasFetchedSpeakers = true;
    }
  },

  updateVisibleSpeakersCount(state, payload) {
    state.visibleSpeakersCount = payload;
  },

  updateIsFetching(state, isFetching) {
    state.isFetching = isFetching;
  },

  updateErrorStatus(state, errorStatus) {
    state.errorStatus = errorStatus;
  },
};

const getters = {
  speakers(state) {
    return state.speakers;
  },

  visibleSpeakersCount(state) {
    return state.visibleSpeakersCount;
  },

  defaultSpeakersCount(state) {
    return state.defaultSpeakersCount;
  },

  isFetching(state) {
    return state.isFetching;
  },

  errorStatus(state) {
    return state.errorStatus;
  },

  hasFetchedSpeakers(state) {
    return state.hasFetchedSpeakers;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
